import React, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './Typo.module.css';

const Typo = forwardRef(function Text(
  {
    variant,
    color,
    align,
    paragraph = false,
    ellipsis = false,
    inline = false,
    className,
    as: Component = paragraph ? 'p' : 'span',
    ...rest
  },
  forwardedRef
) {
  return (
    <Component
      ref={forwardedRef}
      className={classNames(
        styles.root,
        styles[variant],
        styles[color],
        styles[align],
        {
          [styles.paragraph]: paragraph,
          [styles.ellipsis]: ellipsis,
          [styles.inline]: inline
        },
        className
      )}
      {...rest}
    />
  );
});

export default Typo;
